export default __webpack_public_path__ + "static/media/sales_marketing_module_preview.1cd2e18e.png";